export default (component) => {
  if (!component.mixins) {
    component.mixins = []
  }

  component.mixins.push({
    mounted() {
      this.updateLabel()
    },
    updated() {
      this.updateLabel()
    },
    methods: {
      updateLabel() {
        this.$nextTick(() => {
          const increase = this.$el.querySelector('.el-input-number__increase')
          const decrease = this.$el.querySelector('.el-input-number__decrease')

          if (increase) {
            increase.setAttribute('aria-label', 'Increase value')
          }

          if (decrease) {
            decrease.setAttribute('aria-label', 'Decrease value')
          }
        })
      }
    }
  })
}
